/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PeriodTimeEnum } from './PeriodTimeEnum';
import {
    PeriodTimeEnumFromJSON,
    PeriodTimeEnumFromJSONTyped,
    PeriodTimeEnumToJSON,
    PeriodTimeEnumToJSONTyped,
} from './PeriodTimeEnum';

/**
 * Command UNIQUE des 5 routes stats (home/board, objectifs, commercial-flow, revenue, stock). branches null/absent/[] = toutes ; plusieurs codes = union ; "ALL" ignoré. L'ancien champ `branch` (singulier) n'existe plus.
 * 
 * @export
 * @interface GetDashboardStatisticsCommand
 */
export interface GetDashboardStatisticsCommand {
    /**
     * Codes branches du référentiel (cf. availableFilters de la réponse)
     * @type {Array<string>}
     * @memberof GetDashboardStatisticsCommand
     */
    branches?: Array<string> | null;
    /**
     * Courbes en cumul (ignoré par objectifs, sans courbe)
     * @type {boolean}
     * @memberof GetDashboardStatisticsCommand
     */
    cumulative?: boolean;
    /**
     * 
     * @type {PeriodTimeEnum}
     * @memberof GetDashboardStatisticsCommand
     */
    period?: PeriodTimeEnum;
}



/**
 * Check if a given object implements the GetDashboardStatisticsCommand interface.
 */
export function instanceOfGetDashboardStatisticsCommand(value: object): value is GetDashboardStatisticsCommand {
    return true;
}

export function GetDashboardStatisticsCommandFromJSON(json: any): GetDashboardStatisticsCommand {
    return GetDashboardStatisticsCommandFromJSONTyped(json, false);
}

export function GetDashboardStatisticsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDashboardStatisticsCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'branches': json['branches'] == null ? undefined : json['branches'],
        'cumulative': json['cumulative'] == null ? undefined : json['cumulative'],
        'period': json['period'] == null ? undefined : PeriodTimeEnumFromJSON(json['period']),
    };
}

export function GetDashboardStatisticsCommandToJSON(json: any): GetDashboardStatisticsCommand {
    return GetDashboardStatisticsCommandToJSONTyped(json, false);
}

export function GetDashboardStatisticsCommandToJSONTyped(value?: GetDashboardStatisticsCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branches': value['branches'],
        'cumulative': value['cumulative'],
        'period': PeriodTimeEnumToJSON(value['period']),
    };
}

